var applyLink = {
  load:function(){
    this.applyPopup = new jobPopup("applyPopup");

    this.events();
  },
  events:function(){
    var self = this;
    var links = document.getElementsByClassName("applyLink");
    for(let l of links){
      l.addEventListener("click",(e)=>{
        e.preventDefault();
        self.submit(e);
      })
    }
  },
  submit:function(e){
    var self = this;
    jlLoader.show("Loading Contact Details");
    this.hashKey = e.currentTarget.getAttribute("data-hashKey");


    grecaptcha.ready(function() {
       grecaptcha.execute('6Lde0K8bAAAAAIEhPqy5MwzLGFUUi-zvCrBOEW6j', {action: 'submit'}).then(function(token) {
           self.getContact(token);
       });
     });
   },
   contactHTML:function(data){
     var rHTML = "<div class='jobPopupScrollHolder'><center>";

     if(data.logoImage){
       rHTML += '<img src="'+data.logoImage+'" class="jobCompanyLogo"/>';
     }

     rHTML += '<div class="jobTitle">'+data.jobTitle+'</div>';
     rHTML += '<div class="jobCompany">'+data.businessName+'</div>';
     rHTML += "<div class='divider'></div>";

     rHTML += "<big>Submit Your Resume to:</big><br/>";

//     rHTML += '<a href="mailto:'+data.resumeEmail+'?subject=Job Application: '+data.jobTitle.replace(/"/g,"")+' ('+data.businessName.replace(/"/g,"")+')" class="button buttonLarge"><svg xmlns="http://www.w3.org/2000/svg" class="ionicon" viewBox="0 0 512 512"><title>Send</title><path d="M470.3 271.15L43.16 447.31a7.83 7.83 0 01-11.16-7V327a8 8 0 016.51-7.86l247.62-47c17.36-3.29 17.36-28.15 0-31.44l-247.63-47a8 8 0 01-6.5-7.85V72.59c0-5.74 5.88-10.26 11.16-8L470.3 241.76a16 16 0 010 29.39z" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="32"/></svg>'+data.resumeEmail+'</a>';
    rHTML += '<div class="emailLink"><a href="mailto:'+data.resumeEmail+'?subject=Job Application: '+data.jobTitle.replace(/"/g,"")+' ('+data.businessName.replace(/"/g,"")+')">'+data.resumeEmail+'</a><div class="copyLink" onClick="copyEmail(\''+data.resumeEmail+'\')"><svg xmlns="http://www.w3.org/2000/svg" class="ionicon" viewBox="0 0 512 512"><title>Copy</title><rect x="128" y="128" width="336" height="336" rx="57" ry="57" fill="none" stroke="currentColor" stroke-linejoin="round" stroke-width="32"/><path d="M383.5 128l.5-24a56.16 56.16 0 00-56-56H112a64.19 64.19 0 00-64 64v216a56.16 56.16 0 0056 56h24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="32"/></svg></div></div>';
     //rHTML += '<a href="mailto:'+data.resumeEmail+'?subject=Job Application: '+data.jobTitle.replace(/"/g,"")+' ('+data.businessName.replace(/"/g,"")+')" class="outlineButton "><svg xmlns="http://www.w3.org/2000/svg" class="ionicon" viewBox="0 0 512 512"><title>Send</title><path d="M470.3 271.15L43.16 447.31a7.83 7.83 0 01-11.16-7V327a8 8 0 016.51-7.86l247.62-47c17.36-3.29 17.36-28.15 0-31.44l-247.63-47a8 8 0 01-6.5-7.85V72.59c0-5.74 5.88-10.26 11.16-8L470.3 241.76a16 16 0 010 29.39z" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="32"/></svg>'+data.resumeEmail+'</a>';
     rHTML += "</center></div>";
     return rHTML;
   },
   getContact:function(token){
     var self = this;
     fetch(JLAJAX.url+"listing/"+this.hashKey+"/contact",{
       method:"POST",
       headers:{
         'Content-Type':'application/json',
         'Accept':'application/json'
       },
       body:JSON.stringify({
         token:token
       })
     }).then(res=>res.json())
     .then(data=>{
       jlLoader.hide();
       if(data.error){
         alert(data.error);
       }
       else{
         self.applyPopup.setHTML(self.contactHTML(data));
         self.applyPopup.open();
       }





     });
   }


};

var copyEmail = function(email){
  	var textToCopy = email;

		var myTemporaryInputElement = document.createElement("input");
		myTemporaryInputElement.type = "text";
		myTemporaryInputElement.value = textToCopy;

		document.body.appendChild(myTemporaryInputElement);

		myTemporaryInputElement.select();
		document.execCommand("Copy");

		document.body.removeChild(myTemporaryInputElement);
    alert("Application E-Mail Copied to Clipboard");

};
